<template>
  <div class="content">
    <Modal v-model="showModal" title="考试详情" :footer-hide="true" :loading="$root.$children[0].modalLoading" width="1243" class="my-modal top">
      <div class="table-box template-table">
        <loading :isShow="tableLoading" />
        <Table :columns="columns" :data="tableData" border>
          <template slot-scope="{ row }" slot="isPass">
            <span v-if="row.isPass == 1">通过</span>
            <span v-else>未通过</span>
          </template>
        </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      showModal: false,
      tableLoading: false, //表格loading
      columns: [
        //表格字段
        {
          title: '序号',
          align: 'center',
          type: 'index'
        },
        {
          title: '参考人员',
          key: 'agentName',
          align: 'center'
        },
        {
          title: '机构名称',
          key: 'orgName',
          minWidth: 200,
          align: 'center'
        },
        {
          title: '是否通过',
          slot: 'isPass',
          align: 'center'
        },
        {
          title: '考试时间',
          key: 'lastTime',
          align: 'center'
        }
      ],
      tableData: [], //表格数据
      total: 0, //表格记录数
      pageSize: 10, //页容量
      pageNum: 1, //当前页
      search: {}
    };
  },
  created() {},
  methods: {
    getParams() {
      const params = Object.assign({}, this.search);
      return params;
    },
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      const params = this.getParams();
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      params.id = this.id;
      this.tableLoading = true;
      this.$http({
        url: '/buz/testCenter/read/test/detail',
        type: 'post',
        data: params,
        apiPermissionCode: ''
      })
        .then(res => {
          this.tableLoading = false;
          this.tableData = res.data;
          this.total = res.total;
        })
        .catch(e => {
          this.tableLoading = false;
        });
    },
    open(id) {
      if (id) {
        this.id = id;
        this.searchAjax();
      } else {
        this.id = '';
      }
      this.showModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.template-table {
  margin-top: 10px;
}
</style>
